import { FuelAccordionItem, FuelDivider, FuelIcon, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import GenericInfoItem from 'components/ui/GenericInfoItem';
import { DS_TOKENS } from 'constants/styled.contants';
import { textConstants } from 'constants/texts';
import React, { FC, useRef, useState } from 'react';
import AccordionContent from './AccordionContent';
import * as Styled from './styled';

const UsuallyLoads: FC<{ mainProducts: string[] }> = ({ mainProducts }) => {
  const [isOpen, setIsOpen] = useState(false);
  const accordionRef = useRef(null);
  const sectionName = 'Costuma carregar';

  const { noInfoText } = textConstants;

  /* istanbul ignore next */
  const handleToggleAccordion = () => accordionRef?.current?.toggle();

  return (
    <>
      {!!mainProducts?.length ? (
        <>
          <Styled.AccordionWrapper>
            <FuelAccordionItem
              ref={accordionRef}
              onFuel-accordion-close={/* istanbul ignore next */ () => setIsOpen(false)}
              onFuel-accordion-open={/* istanbul ignore next */ () => setIsOpen(true)}
            >
              <Styled.HeaderWrapper
                slot="header"
                onClick={handleToggleAccordion}
                isOpen={isOpen}
                data-testid="test-accordion-header"
              >
                <>
                  <FuelFlex
                    defaultProps={{
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      width: '100%',
                      customPadding: `0 ${DS_TOKENS.spacing.km4} 0 0`,
                    }}
                  >
                    <FuelTypography size="body-md" color="neutral-default" weight="medium">
                      {sectionName}
                    </FuelTypography>
                    {!isOpen && <AccordionContent mainProducts={mainProducts} isHeader />}
                  </FuelFlex>

                  <Styled.ChevronWrapper isOpen={isOpen}>
                    <FuelIcon name="chevron-down" size="medium" />
                  </Styled.ChevronWrapper>
                </>
              </Styled.HeaderWrapper>

              <Styled.ContentWrapper slot="content">
                <AccordionContent mainProducts={mainProducts} />
              </Styled.ContentWrapper>
            </FuelAccordionItem>
          </Styled.AccordionWrapper>
          <FuelDivider />
        </>
      ) : (
        <GenericInfoItem title={sectionName}>
          <FuelTypography weight="medium">{noInfoText}</FuelTypography>
        </GenericInfoItem>
      )}
    </>
  );
};

export default UsuallyLoads;
